export default __webpack_public_path__ + "static/media/info-circle.4515cacf.svg";